import React, { useState, useEffect } from "react";
import {
    Box,
    Button,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography,
    IconButton,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

import { getAuth } from "firebase/auth";
import { db } from "../../firebase";
import { getDoc, doc, serverTimestamp, updateDoc } from "firebase/firestore";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import CloseIcon from "@mui/icons-material/Close";

function InfoEdit() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const [user, setUser] = useState("");
    const [param, setParam] = useState("");

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [youtubeURL, setYoutubeURL] = useState("");
    const [embedCode, setEmbedCode] = useState("");

    const handleTitleChange = (event) => {
        setTitle(event.target.value);
    };

    const handleDescriptionChange = (event) => {
        setDescription(event.target.value);
    };

    const handleYoutubeURLChange = (event) => {
        setYoutubeURL(event.target.value);
    };

    const handleEmbedCodeChange = (event) => {
        setEmbedCode(event.target.value);
    };

    const handleUpdateClick = async () => {
        try {
            const documentRef = doc(db, "info", param);
            await updateDoc(documentRef, {
                title: title,
                description: description,
                embedCode: embedCode,
                youtubeURL: youtubeURL,
                auther: user,
                updateAt: serverTimestamp(),
            });
        } catch (error) {
            console.error("error: ", error);
        }

        setSaveOpen(true);
    };

    const [saveOpen, setSaveOpen] = useState(false);
    const handleSaved = () => {
        window.scrollTo(0, 0);
        navigate("/info", { replace: true });
    };

    const [loadButton, setLoadButton] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const handleDeleteClose = () => {
        setDeleteOpen(false);
    };

    const handleDelete = () => {
        setDeleteOpen(true);
    };

    const handleDeleteComp = async () => {
        setLoadButton(true);

        const videoRef = doc(db, "video", param);

        await updateDoc(videoRef, {
            deleted: true,
            deleteAt: serverTimestamp(),
        });

        setLoadButton(false);
        setDeleteCompOpen(true);
    };

    const [deleteCompOpen, setDeleteCompOpen] = useState(false);
    const handleDeleteComped = () => {
        window.scrollTo(0, 0);
        navigate("/info", { replace: true });
    };

    const fetchData = async (uid) => {
        const params = window.location.pathname.split("/")[2];
        setParam(params);

        const infoRef = doc(db, "info", params);
        const infoSnap = await getDoc(infoRef);
        setTitle(infoSnap.data().title);
        setDescription(infoSnap.data().description);
        setYoutubeURL(infoSnap.data().youtubeURL);
        setEmbedCode(infoSnap.data().embedCode);

        setLoading(false);
    };

    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged((userLogin) => {
            if (userLogin) {
                const uid = userLogin.uid;
                setUser(uid);
                fetchData(uid);
            } else {
                window.scrollTo(0, 0);
                navigate("/login", { replace: true });
            }
        });

        return () => unsubscribe();
    }, []);

    if (loading) {
        return (
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <div>
            <Helmet>
                <title>Info Edit - SOG Member Site</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Container maxWidth="1280" sx={{ display: { xs: { maxWidth: 0 } }, maxWidth: 1280 }}>
                <Container>
                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ mt: 10 }}
                    >
                        <Typography variant="h6">お知らせ編集</Typography>
                    </Box>

                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ m: 3 }}
                    >
                        <TextField variant="filled" label="タイトル" value={title} onChange={handleTitleChange} sx={{ minWidth: 350 }} />
                    </Box>

                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ m: 3 }}
                    >
                        <TextField
                            variant="filled"
                            label="内容"
                            value={description}
                            onChange={handleDescriptionChange}
                            multiline
                            rows={5}
                            sx={{ minWidth: 350 }}
                        />
                    </Box>

                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ m: 3 }}
                    >
                        <TextField variant="filled" label="YouTube URL" value={youtubeURL} onChange={handleYoutubeURLChange} sx={{ minWidth: 350 }} />
                    </Box>

                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ m: 3 }}
                    >
                        <TextField
                            variant="filled"
                            label="埋め込みコード"
                            value={embedCode}
                            onChange={handleEmbedCodeChange}
                            sx={{ minWidth: 350 }}
                        />
                    </Box>

                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ mt: 5 }}
                    >
                        <Button variant="contained" onClick={handleUpdateClick} size="large" sx={{ width: "350px" }}>
                            更新
                        </Button>
                    </Box>

                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ mt: 3, mb: 2 }}
                    >
                        <Button color="error" variant="contained" onClick={handleDelete} size="large" sx={{ width: "350px" }}>
                            削除
                        </Button>
                    </Box>
                </Container>
            </Container>

            <Dialog open={saveOpen}>
                <DialogTitle
                    sx={{
                        minWidth: 263,
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    更新しました
                </DialogTitle>
                <DialogActions sx={{ justifyContent: "center", display: "flex", mb: 2 }}>
                    <Button variant="contained" sx={{ width: "100px" }} onClick={handleSaved}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteOpen} onClose={handleDeleteClose}>
                <DialogTitle sx={{ mb: 2, minWidth: 263 }}>
                    <IconButton
                        onClick={handleDeleteClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Typography style={{ display: "flex", justifyContent: "center" }}>削除しますか？</Typography>
                </DialogContent>
                <DialogActions>
                    <LoadingButton onClick={handleDeleteClose} variant="outlined" loading={loadButton} loadingIndicator="削除中">
                        キャンセル
                    </LoadingButton>
                    <LoadingButton onClick={handleDeleteComp} variant="contained" loading={loadButton}>
                        OK
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteCompOpen}>
                <DialogTitle
                    sx={{
                        minWidth: 263,
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    YouTubeリンクを削除しました
                </DialogTitle>
                <DialogActions sx={{ justifyContent: "center", display: "flex", mb: 2 }}>
                    <Button variant="contained" sx={{ width: "100px" }} onClick={handleDeleteComped}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default InfoEdit;
